import React from 'react';
import ToolRunButton from '@/components/Tools/ToolRunButton';

/**
 * Primary CTA for running a prompt. Reuses the Tool gradient button chrome;
 * label/icon come from the prompt's `runButtonLabel` / `runButtonIcon`.
 */
function PromptGenerateButton({
  label = 'Generate',
  loadingLabel = 'Starting…',
  icon = 'wand-magic-sparkles',
  isLoading = false,
  isDisabled = false,
  onPress,
}) {
  return (
    <ToolRunButton
      label={label}
      loadingLabel={loadingLabel}
      icon={icon || 'wand-magic-sparkles'}
      isLoading={isLoading}
      isDisabled={isDisabled}
      onPress={onPress}
      isFullWidth
    />
  );
}

export default React.memo(PromptGenerateButton);
